import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@app/environment/environment';
import { extractFilenameFromCD, saveBlob } from '@app/helpers/fileDownload';
import { map, Observable, tap } from 'rxjs';

export type ApprovalRequestId = string;
export type ApprovalRequestUpdate = Readonly<{ isApproved: boolean }>;
@Injectable({ providedIn: 'root' })
export class DownloadService {
  private readonly http = inject(HttpClient);
  private readonly API_URL = environment.apiUrl;

  downloadFileById(
    fileId: string,
    fallbackName = 'document'
  ): Observable<void> {
    const url = `${this.API_URL}/File/${fileId}`;
    return this.http
      .get(url, { responseType: 'blob', observe: 'response' as const })
      .pipe(
        tap((resp: HttpResponse<Blob>) => {
          const blob = resp.body as Blob;
          const cd = resp.headers.get('content-disposition');
          const name = extractFilenameFromCD(cd) ?? fallbackName;
          saveBlob(blob, name);
        }),
        map(() => void 0)
      );
  }
}
